import axios from 'axios'
import { API_URL, CONTENT_TYPE, METHOD_AXIOS } from '../utils/constant'
import { serializeForm } from '../utils/function.utils'

/** Build a stable message for UI / err.message in redux catch blocks. */
function normalizeAxiosError(err) {
	if (err.response) {
		const data = err.response.data
		if (typeof data === 'string') {
			return new Error(data)
		}
		if (data != null && typeof data === 'object') {
			try {
				return new Error(JSON.stringify(data))
			} catch {
				return new Error('Request failed')
			}
		}
		return new Error(String(data ?? 'Request failed'))
	}
	if (err instanceof Error) {
		return err
	}
	return new Error(String(err?.message ?? err))
}

async function request(config) {
	try {
		const response = await axios(config)
		return response ? response.data : response
	} catch (err) {
		throw normalizeAxiosError(err)
	}
}

export class BaseApi {
	constructor(pathUrl) {
		const base = String(API_URL || '').replace(/\/+$/, '')
		const prefix = pathUrl ? `${base}/${String(pathUrl).replace(/^\/+/, '')}` : `${base}/`
		this.URL = prefix.endsWith('/') ? prefix : `${prefix}/`
	}

	buildUrl(path) {
		const p = String(path || '').replace(/^\/+/, '')
		return `${this.URL}${p}`
	}

	baseConfig(overrides) {
		return {
			withCredentials: true,
			...overrides,
		}
	}

	async requestJson(path, data, method = METHOD_AXIOS.GET) {
		return request(
			this.baseConfig({
				method,
				url: this.buildUrl(path),
				data,
				headers: {
					'Content-Type': 'application/json;charset=UTF-8',
				},
			})
		)
	}

	async methodWithFormData(
		path,
		data,
		method = METHOD_AXIOS.GET,
		contentType = CONTENT_TYPE.MULTIPART_FORM_DATA
	) {
		const bodyFormData = new FormData()
		Object.keys(data).forEach(item => {
			bodyFormData.append(item, data[item])
		})
		return request(
			this.baseConfig({
				method,
				url: this.buildUrl(path),
				data: bodyFormData,
				headers: {
					'Content-Type': contentType,
				},
			})
		)
	}

	async methodWithFormDataUrlEncoded(
		path,
		data,
		method = METHOD_AXIOS.GET,
		contentType = CONTENT_TYPE.FORM_URLENCODED
	) {
		const bodyFormData = serializeForm(data)
		return request(
			this.baseConfig({
				method,
				url: this.buildUrl(path),
				data: bodyFormData,
				headers: {
					'Content-Type': contentType,
				},
			})
		)
	}

	async get(path, data) {
		return this.requestJson(path, data, METHOD_AXIOS.GET)
	}
	async post(path, data) {
		return this.requestJson(path, data, METHOD_AXIOS.POST)
	}
	async put(path, data) {
		return this.requestJson(path, data, METHOD_AXIOS.PUT)
	}
	async delete(path, data) {
		return this.requestJson(path, data, METHOD_AXIOS.DELETE)
	}
}
